import { Set } from "immutable";
import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { WidgetType } from "scenes/cohort-filters/filter-configs/widgetTypes";

export const switchWithSelectAndTagsFieldConstructor = ({
    pathToSwitchQuestion,
    pathToSelectValue,
    pathToValue,
    category = Category.OTHER,
    label,
    nestedComponent = false,
    selectOptions,
    tagsValues,
}) => ({
    [pathToValue]: {
        widgetType: WidgetType.SWITCH_WITH_SELECT_AND_TAGS,
        category: nestedComponent ? undefined : category,
        defaultRuleProperties: {
            value: {
                type: "switchWithSelectAndTags",
                tagsValue: Set(),
                switchValue: {
                    field: pathToSwitchQuestion,
                    value: true,
                },
                selectValue: {
                    field: pathToSelectValue,
                    value: "",
                },
            },
        },
        widgetConfig: {
            label: label,
            tagsValues,
            selectValues: selectOptions,
        },
    },
});
